/* Página «Avaliar a compra» (me-avaliar-*, 22/09/2026).
   Lê ?t=<token> (link do email), pede ao serviço próprio os artigos da encomenda e os textos
   na língua da página, e envia uma avaliação por artigo. ?sair=1 → confirmação de opt-out
   (só com clique: um POST, nunca ao abrir o link). Sem dependências. */
(function () {
  var raiz = document.querySelector('.me-av');
  if (!raiz) return;
  var API = (raiz.getAttribute('data-api') || '').replace(/\/+$/, '');
  var LANG = (raiz.getAttribute('data-lang') || 'pt').toLowerCase().slice(0, 2);
  var ROOT = raiz.getAttribute('data-root') || '/';
  var q = new URLSearchParams(location.search);
  var TOKEN = q.get('t') || '';
  var SAIR = q.get('sair') === '1';
  var T = {};
  var estado = raiz.querySelector('.me-av__estado');
  var lista = raiz.querySelector('.me-av__itens');
  var FALHA = { pt: 'Não foi possível carregar. Tente de novo daqui a pouco.',
                en: 'Could not load. Please try again shortly.',
                es: 'No se ha podido cargar. Inténtalo de nuevo en unos minutos.',
                fr: 'Chargement impossible. Veuillez réessayer dans quelques instants.',
                de: 'Laden fehlgeschlagen. Bitte versuchen Sie es gleich noch einmal.',
                it: 'Caricamento non riuscito. Riprova tra poco.' };

  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function textos(t) {
    T = t || {};
    raiz.querySelectorAll('[data-t]').forEach(function (n) {
      var k = n.getAttribute('data-t');
      if (T[k]) n.textContent = T[k];
    });
  }
  function aviso(txt) { estado.textContent = txt || ''; }

  function localizar(item, img, nome) {
    // título e foto na língua da página, direto da loja (mesma origem, sem custo)
    if (!item.handle) return;
    fetch(ROOT.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(item.handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        if (p.title) nome.textContent = p.title;
        if (!img.src && p.featured_image) img.src = p.featured_image;
      }).catch(function () {});
  }

  function cartao(item, primeiroNome) {
    var c = el('div', 'me-av__item');
    var img = el('img', 'me-av__foto');
    img.alt = '';
    img.loading = 'lazy';
    if (item.imagem) img.src = item.imagem + (item.imagem.indexOf('?') < 0 ? '?' : '&') + 'width=200';
    var corpo = el('div');
    var nome = el('p', 'me-av__nome', item.titulo || '');
    corpo.appendChild(nome);
    corpo.appendChild(el('span', 'me-av__verif', '✓ ' + (T.verificada || '')));
    localizar(item, img, nome);
    c.appendChild(img);
    c.appendChild(corpo);
    if (item.avaliado) {
      corpo.appendChild(el('p', 'me-av__msg is-ok', T.ja));
      return c;
    }
    var f = el('form');
    f.noValidate = true;
    var nota = 0;
    f.appendChild(el('label', null, T.nota));
    var est = el('div', 'me-av__estrelas');
    est.setAttribute('role', 'radiogroup');
    est.setAttribute('aria-label', T.nota || '');
    var botoes = [];
    for (var i = 1; i <= 5; i++) {
      (function (n) {
        var b = el('button', 'me-av__estrela', '★');
        b.type = 'button';
        b.setAttribute('aria-label', n + ' / 5');
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          nota = n;
          botoes.forEach(function (x, k) {
            x.classList.toggle('is-on', k < n);
            x.setAttribute('aria-pressed', k === n - 1 ? 'true' : 'false');
          });
        });
        botoes.push(b);
        est.appendChild(b);
      })(i);
    }
    f.appendChild(est);
    function campo(rotulo, tag, nomeCampo, valor, max) {
      f.appendChild(el('label', null, rotulo));
      var x = el(tag);
      if (tag === 'input') x.type = 'text';
      x.name = nomeCampo;
      x.maxLength = max;
      if (valor) x.value = valor;
      f.appendChild(x);
      return x;
    }
    var tit = campo(T.titulo_campo, 'input', 'titulo', '', 120);
    var txt = campo(T.texto_campo, 'textarea', 'texto', '', 2000);
    var nom = campo(T.nome_campo, 'input', 'nome', primeiroNome, 60);
    var arm = el('input', 'me-av__armadilha');
    arm.name = 'site'; arm.tabIndex = -1; arm.autocomplete = 'off';
    arm.setAttribute('aria-hidden', 'true');
    f.appendChild(arm);
    var btn = el('button', 'me-av__enviar', T.enviar);
    btn.type = 'submit';
    f.appendChild(btn);
    var msg = el('p', 'me-av__msg');
    f.appendChild(msg);
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      msg.className = 'me-av__msg is-erro';
      if (!nota) { msg.textContent = T.nota + ' ★'; return; }
      if ((txt.value || '').trim().length < 10) { msg.textContent = T.curto; return; }
      btn.disabled = true;
      fetch(API + '/api/avaliar', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ t: TOKEN, produto_id: item.produto_id, nota: nota,
          titulo: tit.value, texto: txt.value, nome: nom.value, lingua: LANG, armadilha: arm.value })
      }).then(function (r) { return r.json().then(function (j) { return [r.status, j]; }); })
        .then(function (res) {
          var st = res[0], j = res[1] || {};
          if (j.ok) {
            f.replaceWith(el('p', 'me-av__msg is-ok', j.teste ? T.teste : T.obrigado));
          } else if (st === 409 || j.erro === 'ja') {
            f.replaceWith(el('p', 'me-av__msg is-ok', T.ja));
          } else {
            msg.textContent = j.erro === 'texto curto' ? T.curto : T.erro;
            btn.disabled = false;
          }
        }).catch(function () { msg.textContent = T.erro; btn.disabled = false; });
    });
    corpo.appendChild(f);
    return c;
  }

  function sair(forte) {
    var b = raiz.querySelector('.me-av__sair-btn');
    b.textContent = T.sair;
    b.hidden = false;
    if (forte) b.classList.add('is-forte');
    b.addEventListener('click', function () {
      b.disabled = true;
      fetch(API + '/api/avaliar/sair?t=' + encodeURIComponent(TOKEN), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lingua: LANG })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j.ok) { lista.innerHTML = ''; b.hidden = true; aviso(T.sair_ok); }
        else { aviso(T.erro); b.disabled = false; }
      }).catch(function () { aviso(T.erro); b.disabled = false; });
    });
  }

  fetch(API + '/api/avaliar?l=' + LANG + '&t=' + encodeURIComponent(TOKEN))
    .then(function (r) { return r.json(); })
    .then(function (j) {
      textos(j.textos);
      if (!j.ok) { aviso(T.invalido); return; }
      if (j.teste) {
        var tb = raiz.querySelector('.me-av__teste');
        tb.textContent = T.teste; tb.hidden = false;
      }
      if (j.optout) { aviso(T.sair_ok); return; }
      if (SAIR) { sair(true); return; }
      (j.itens || []).forEach(function (it) { lista.appendChild(cartao(it, j.primeiro_nome)); });
      sair(false);
    })
    .catch(function () { aviso(FALHA[LANG] || FALHA.en); });
})();
